
















































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome/src/components/FontAwesomeIcon'
import { ciInfoCircle } from '~/icons/source/solid/info-circle'

export default defineComponent({
  props: {
    showFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    modalSize: {
      type: String,
      required: false,
      default: 'md'
    },
    forceBlue: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: false,
      default: 18
    },
    title: {
      type: String,
      required: false,
      default() {
        return this.$t('information')
      }
    },
    icon: {
      type: Object as PropType<FontAwesomeIcon>,
      required: false,
      default: null
    },
    okText: {
      type: String,
      required: false,
      default() {
        return 'OK'
      }
    },
    bodyClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    defaultIcon() {
      return ciInfoCircle
    },
    iconToShow() {
      return this.icon || this.defaultIcon
    }
  }
})
